/**
 * Permission mode config shared by PermissionsDropdown and TaskConfirmationModal.
 *
 * Modes control how the agent handles tool approval:
 * - "safe" (Approval): Agent pauses and asks the user before executing write tools.
 * - "plan" (Plan): Agent presents a plan for approval before executing.
 * - "yolo" (Autonomous): Agent executes all tools without asking.
 */

import { FastForward, ShieldCheck } from "lucide-react";
import { ClipboardList } from "@/components/animate-ui/icons/clipboard-list";

export type PermissionMode = "safe" | "plan" | "yolo";

export const PERMISSION_MODES: {
	value: PermissionMode;
	label: string;
	description: string;
	icon: React.ComponentType<{ className?: string }>;
}[] = [
	{
		value: "safe",
		label: "Approval",
		description: "Asks for approval before executing actions",
		icon: ShieldCheck,
	},
	{
		value: "plan",
		label: "Plan",
		description: "Presents a plan for approval before executing",
		icon: ClipboardList,
	},
	{
		value: "yolo",
		label: "Autonomous",
		description: "Executes all actions without asking",
		icon: FastForward,
	},
];
